import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { AppstoreOutlined, FolderOpenOutlined, RightOutlined } from "@ant-design/icons";
import DataRoomQuickCreateForm from "./DataRoomQuickCreateForm";
import "./CreateProjectTypeModal.scss";

// Each option maps to the project's `layout`: "default" opens the standard
// project form, "dataroom" creates the project here and opens the editor.
const PROJECT_TYPES = [
  {
    layout: "default",
    title: "Normal Project",
    description: "The standard project page with its details, data room and extended data room tabs.",
    icon: <AppstoreOutlined />
  },
  {
    layout: "dataroom",
    title: "New Design Data Room",
    description: "The redesigned Data Room dashboard. Add the basics, then build it in the editor.",
    icon: <FolderOpenOutlined />
  }
];

const CreateProjectTypeModal = ({ open, onCancel, onSelectNormal, onDataRoomCreated }) => {
  const [step, setStep] = useState("choose");

  // Always start from the chooser when the modal is reopened.
  useEffect(() => {
    if (open) setStep("choose");
  }, [open]);

  const handleSelect = (layout) => {
    if (layout === "dataroom") {
      setStep("dataroom");
    } else {
      onSelectNormal();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={640}
      destroyOnClose
      maskClosable={step === "choose"}
      title={step === "dataroom" ? "New Design Data Room" : "What would you like to create?"}
      className="create-project-type-modal"
    >
      {step === "dataroom" ? (
        <DataRoomQuickCreateForm onBack={() => setStep("choose")} onCreated={onDataRoomCreated} />
      ) : (
        <div className="create-project-type-grid">
          {PROJECT_TYPES.map((type) => (
            <button
              key={type.layout}
              type="button"
              className="create-project-type-card"
              onClick={() => handleSelect(type.layout)}
            >
              <span className="create-project-type-icon">{type.icon}</span>
              <span className="create-project-type-title">{type.title}</span>
              <span className="create-project-type-description">{type.description}</span>
              <span className="create-project-type-cta">
                {type.layout === "dataroom" ? "Continue" : "Create"} <RightOutlined />
              </span>
            </button>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default CreateProjectTypeModal;
